import { projectDocumentSchema } from './schema/document.js';
import type { ProjectDocument } from './types.js';

export interface ValidationIssue {
  readonly path: string;
  readonly message: string;
}

export type ValidationResult =
  | { readonly ok: true; readonly document: ProjectDocument }
  | { readonly ok: false; readonly issues: readonly ValidationIssue[] };

export function validateDocument(input: unknown): ValidationResult {
  const result = projectDocumentSchema.safeParse(input);
  if (result.success) return { ok: true, document: result.data };
  return {
    ok: false,
    issues: result.error.issues.map((i) => ({
      path: i.path.map(String).join('.'),
      message: i.message,
    })),
  };
}
